import { Box, Grid, Typography } from "@mui/material";
import { ConfigurationListSubheader } from "~/components/configuration-items";
import { IntegrationAddHeader } from "../../headers/IntegrationAddHeader";
import { App } from "../IntegrationSetupPage";
import { IntegrationSetupDetailAddDefaultConfig } from "~/pages/integrations/IntegrationsSetup/IntegrationSetupDetail/IntegrationSetupDetailAddDefaultConfig";
import { OrganizationScope, SpaceScope } from "~/hooks/useScope";
import { OtherIntegrations } from "../../headers/types";

interface IntegrationSetupDetailProps {
  scope: SpaceScope | OrganizationScope;
  item: App | null;
}

export function IntegrationSetupDetail({
  scope,
  item,
}: IntegrationSetupDetailProps) {
  if (item == null) {
    return <></>;
  }

  return (
    <Box>
      <IntegrationAddHeader type={item.id as OtherIntegrations} />
      <Grid container spacing={3}>
        <Grid size={12}>
          <ConfigurationListSubheader component="div">
            <Typography component="span" variant="h6">
              Configuration
            </Typography>
          </ConfigurationListSubheader>
          <IntegrationSetupDetailAddDefaultConfig item={item} scope={scope} />
        </Grid>
      </Grid>
    </Box>
  );
}
